import { gql } from "@apollo/client";

export const CUSTOMER_SIGNUP = gql`
  mutation CustomerSignUp($userId: ID!, $input: CustomerInput) {
    customerSignUp(user_id: $userId, input: $input) {
      user {
        id
        name
        email
        phone
        address {
          country
          city
          area
          landmark
          lat
          lng
          id
        }
        reseller {
          id
          shop {
          id
        }
          email
          name
          country
        }
      }
      token
    }
  }
`;

export const CUSTOMER_SIGNIN = gql`
  mutation CustomerSignIn($input: CustomerLoginInput) {
    customerSignIn(input: $input) {
      token
      user {
        id
        email
        name
        phone
        address {
          area
          city
          country
          landmark
        }
        reseller {
          name
          phone
          email
          country
          username
        }
      }
    }
  }
`;

export const CREATE_CUSTOMER_ADDRESS = gql`
  mutation CreateCustomerAddress($customerId: ID!, $input: AddressInput) {
    createCustomerAddress(customer_id: $customerId, input: $input) {
      id
      landmark
      area
      city
    }
  }
`;

export const CREATE_ORDER = gql`
  mutation CreateOrder( $input: OrderCreateInput) {
    createOrder( input: $input)
  }
`;

export const VERIFY_OTP = gql`
  mutation VerifyOTP($input: verifyOTPInput) {
    verifyOTP(input: $input)
  }
`;
export const REQUEST_OTP = gql`
mutation RequestOTP($input: requestOTPInput) {
  requestOTP(input: $input) {
    token
  }
}
`;
export const UPDATE_CUSTOMER_INFORMATION = gql`
mutation UpdateCustomer($input: CustomerInput) {
  updateCustomer(input: $input)
}
`;
export const DELETE_CUSTOMER_ADDRESS = gql`
mutation RemoveCustomerAddress($removeCustomerAddressId: ID!) {
  removeCustomerAddress(id: $removeCustomerAddressId)
}
`;

export const getCheckoutLink = gql`
  mutation GetCheckOutLInk($data: MakeTinggPaymentRequestDto) {
    makePayment(data: $data)
  }
`;

